/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface UserGoalInterface {
  "goalId": string;
  "categoryId": string;
  "userGoalText": string;
  "id"?: any;
  "patientId"?: any;
  "created"?: Date;
  patient?: Patient;
}

export class UserGoal implements UserGoalInterface {
  "goalId": string;
  "categoryId": string;
  "userGoalText": string;
  "id": any;
  "patientId": any;
  "created": Date;
  patient: Patient;
  constructor(data?: UserGoalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserGoal`.
   */
  public static getModelName() {
    return "UserGoal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserGoal for dynamic purposes.
  **/
  public static factory(data: UserGoalInterface): UserGoal{
    return new UserGoal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserGoal',
      plural: 'UserGoals',
      path: 'UserGoals',
      idName: 'id',
      properties: {
        "goalId": {
          name: 'goalId',
          type: 'string'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'string'
        },
        "userGoalText": {
          name: 'userGoalText',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
